import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SingleCoin } from "../config/api";
import { CurrencyState } from "../Context";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { LinearProgress } from "@mui/material";
import ReactHtmlParser from "react-html-parser";
import Popup from "../components/Popup";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";


//Icons
import bitcoinIcon from '../assets/bitcoin.svg';
import ethereumIcon from '../assets/ethereum.svg';
import binanceCoinIcon from '../assets/binance.svg';
import rippleIcon from '../assets/xrp.svg';


function AssetPage() {

    const { id } = useParams();
    const [coin, setCoin] = useState();
    const { currency, symbol } = CurrencyState();

    const fetchCoin = async () => {
        const { data } = await axios.get(SingleCoin(id));
        setCoin(data);
    };

    useEffect(() => {
        fetchCoin();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, currency]);


    const [chartPopup, setChartPopup] = useState(false);

    //Change chart period when a user clicks the period

    const handleChartSelected = (id) => {
        setPeriod(id);
    };

    const dayChart = () => {
        handleChartSelected(1);
    };

    const weekChart = () => {
        handleChartSelected(7);
    };

    const monthChart = () => {
        handleChartSelected(30);
    };

    const yearChart = () => {
        handleChartSelected(365);
    };

    //Coin performance


    const [chartData, setChartData] = useState()
    const [period, setPeriod] = useState(1);

    const performance = [
        {
            name: "Page A",
            price: 4000,
            time: 2400,
            amt: 2400,
        },
        {
            name: "Page B",
            price: 3000,
            time: 1398,
            amt: 2210,
        },
        {
            name: "Page C",
            price: 2000,
            time: 9800,
            amt: 2290,
        },
        {
            name: "Page D",
            price: 2780,
            time: 3908,
            amt: 2000,
        },
        {
            name: "Page E",
            price: 1890,
            time: 4800,
            amt: 2181,
        },
        {
            name: "Page F",
            price: 2390,
            time: 3800,
            amt: 2500,
        },
        {
            name: "Page G",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page H",
            price: 2780,
            time: 3908,
            amt: 2000,
        },
        {
            name: "Page I",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page J",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page K",
            price: 2780,
            time: 3908,
            amt: 2000,
        },
        {
            name: "Page L",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page M",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page N",
            price: 2780,
            time: 3908,
            amt: 2000,
        },
        {
            name: "Page O",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page P",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page Q",
            price: 2000,
            time: 9800,
            amt: 2290,
        },
        {
            name: "Page R",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page S",
            price: 4000,
            time: 2400,
            amt: 2400,
        },
        {
            name: "Page T",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page U",
            price: 2000,
            time: 9800,
            amt: 2290,
        },
        {
            name: "Page V",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page W",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page X",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
        {
            name: "Page Y",
            price: 1890,
            time: 4800,
            amt: 2181,
        },
        {
            name: "Page Z",
            price: 3490,
            time: 4300,
            amt: 2100,
        },
    ];

    if (!coin) return <LinearProgress style={{ backgroundColor: "var(--primary)" }} />;

    document.title = coin.name + " Overview";

    return (

        <>

            <Popup trigger={chartPopup} setTrigger={setChartPopup}>

                <Chartbox>

                    <h3>{coin.name}</h3>
                    <h1>{symbol} {coin.market_data.current_price[currency.toLowerCase(2)].toFixed(2)}</h1>
                    <p>{coin.price_change_percentage_24h < 0 ? (
                        <span className="red">
                            {coin.market_data.price_change_percentage_24h.toFixed(2)}%
                        </span>
                    ) : (
                        <span className="green">
                            {coin.market_data.price_change_percentage_24h.toFixed(2)}%
                        </span>
                    )} over the last day</p>

                    <Chart>

                        <TimelineButtons>
                            <button onClick={dayChart}>Day</button>
                            <button onClick={weekChart}>Week</button>
                            <button onClick={monthChart}>Month</button>
                            <button onClick={yearChart}>Year</button>
                        </TimelineButtons>
                        <ResponsiveContainer width="100%" height="40%">
                            <LineChart
                                width={500}
                                height={300}
                                data={performance}
                                margin={{
                                    top: 10,
                                    right: 0,
                                    left: 0,
                                    bottom: 0,
                                }}
                            >
                                <Tooltip contentStyle={{ display: "none" }} cursor={false} />
                                <Line
                                    type="monotone"
                                    dataKey="price"
                                    stroke="var(--primary)"
                                    strokeWidth="4" dot={{
                                        fill: "var(--primary)",
                                        stroke: "var(--primary-darker)", strokeWidth: 2, r: 3
                                    }}
                                    activeDot={{
                                        fill: "var(--primary)", stroke: "var(--primary-darker)",
                                        strokeWidth: 5, r: 7
                                    }} />
                            </LineChart>
                        </ResponsiveContainer>
                    </Chart>

                </Chartbox>

            </Popup>


            <Container>
                <CoinHero>
                    <img src={coin.image.small} />
                    <h1>{symbol} {coin.market_data.current_price[currency.toLowerCase()].toFixed(2)}</h1>
                    <CoinsButtons>
                        <Link to={`/AssetPage/bitcoin`}><button><img src={bitcoinIcon} /></button></Link>
                        <Link to={`/AssetPage/ethereum`}><button><img src={ethereumIcon} /></button></Link>
                        <Link to={`/AssetPage/binancecoin`}><button><img src={binanceCoinIcon} /></button></Link>
                        <Link to={`/AssetPage/ripple`}><button><img src={rippleIcon} /></button></Link><br />
                    </CoinsButtons>
                    <button className="view-chart" onClick={() => setChartPopup(true)}>View Chart</button>
                </CoinHero>

                <Box><br />

                    <BuyForm>

                        <h1>Invest in {coin.name}</h1>
                        <p>The number of shares are estimated based on the investment value and will execute at the live price.</p>

                        <Warning>

                            <p>
                                <b>Risk Disclaimer</b><br />
                                <span>
                                    Before investing in any crypto asset ensure that you have considered the following questions:<br />
                                    - Am I comfortable with the level of risk?<br />
                                    - Do I fully understand the investment being offered?<br />
                                    - Am I protected if things go wrong?<br />
                                    - Are my investments regulated?<br />
                                    - Should I get financial advice?<br />
                                </span>
                            </p>
                        </Warning>

                        <form>
                            <select disabled>
                                <option>{currency}</option>
                            </select>
                            <input name="amount" type="number" placeholder="Investment Amount" /><br />
                            <button type='submit'>Next</button>
                        </form>

                    </BuyForm>

                </Box>

                <AboutCoin>

                    <h2>About {coin.name}</h2>

                    <p>{ReactHtmlParser(coin.description.en.split(". ")[0])}</p>

                </AboutCoin>

            </Container>
        </>
    )
}

export default AssetPage

const Container = styled.div`

`

const CoinHero = styled.div`
    height: 60vh;
    width: 100%;
    padding-top: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #333;
    background: #f5f8ff;

    img {
        width: 60px;
        height: 60px;
        border-radius: 10px;
    }

    h1 {
        padding: 5px 0;
        text-transform: uppercase;
        font-size: 48px;
        font-weight: 600;
    }

    .view-chart {
        width: 170px;
        border-radius: 10px;
        height: 50px;
        margin-top: 20px;
        background: var(--primary);
        color: #fff;
        border: none;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 20px;

        :hover {
            background-color: transparent;
            transition: 0.2s ease-in-out;
            color: var(--primary);
            border-radius: 30px;
            border: 2px solid var(--primary);
        }
    }

    @media (max-width: 928px) {

        img {
            width: 50px;
            height: 50px;
        }

        h1 {
            font-size: 38px;
        }

        button {
            width: 50px;
            height: 50px;
            font-size: 12px;
        }
    }

`

const CoinsButtons = styled.div`

    display: flex;
    justify-content: center;
    align-items: center;

        button {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background-color: transparent;
            font-size: 11px;
            font-weight: 600;
            margin-left: 10px;
            justify-content: center;
            align-items: center;
            display: flex;
            border: none;

            :hover {
                transition: 0.2s ease-in-out;
                box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
            }

            @media (max-width: 900px){
                width: 40px;
                height: 40px;
            }
        }

    img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        opacity: 0.9;

        :hover {
            opacity: 1;
            transition: 0.2s ease-in;
        }

         @media (max-width: 900px){
            width: 30px;
            height: 30px;
        }
`

const AboutCoin = styled.div` 

    background-color: #fff;
    width: 60%;
    height: 200px;
    box-shadow: rgba(99, 99, 99, 0.4) 0px 2px 8px 0px;
    margin: 0 auto;
    margin-top: 20px;
    text-align: center;
    margin-bottom: 20px;
    border-radius: 10px;
    justify-content: center;
    align-item: center;

    p {
        padding: 20px;
        font-size: 14px;
        color: #333;
    }

    h2 {
      padding-top: 30px;
      color: #333;
    }

    @media (max-width: 928px) {
        width: 95%;
        height: 270px;
    }

`

const Box = styled.div`
    background-color: #fff;
    width: 60%;
    height: 520px;
    box-shadow: rgba(99, 99, 99, 0.4) 0px 2px 8px 0px;
    margin: 0 auto;
    margin-top: 20px;
    text-align: center;

    h1 {
        padding-top: 50px;
        font-weight: 400;
        font-size: 42px;
    }

    @media (max-width: 928px) {
        width: 95%;
        margin-top: 0px;
    }
`

const BuyForm = styled.div`

    h1 {
        padding-top: 10px;
        font-weight: 600;
        font-size: 36px;
    }

    p {
        font-size: 12px;
        color: grey;
        width: 90%;
        margin: 0 auto;
    }

    input {
        width: 50%;
        height: 50px;
        border: 2px solid green;
        outline: none;
        padding-left: 20px;
        margin-top: 20px;
        
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    margin: 0;
    }

    select {
        width: 10%;
        height: 50px;
        border: 2px solid var(--primary);
        outline: none;
        text-align: center;
        font-weight: bold;
        margin-right: 5px;
        -webkit-appearance: none;
        -moz-appearance: none;
        text-transform: uppercase;
        background-color: var(--primary);
        color: #fff;
    }

    button {
        width: 350px;
        height: 50px;
        margin-top: 20px;
        text-transform: uppercase;
        background-color: var(--primary);
        border: none;
        color: #fff;
        box-shadow: inset -2px -2px 5px rgba(255, 255, 255, 0.1), inset 2px 2px 5px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        font-weight: 600;

        :hover {
             background-color: transparent;
            transition: 0.2s ease-in-out;
            color: var(--primary);
            border-radius: 30px;
            border: 2px solid var(--primary);
        }
    }

    @media (max-width: 928px) {

        h1 {
            padding-top: 10px;
            font-weight: 600;
            font-size: 20px;
        }

        input {
            width: 70%;
            height: 50px;
            border: 2px solid green;
            outline: none;
            padding-left: 20px;
        }

        select {
            width: 20%;
            height: 50px;
            border: 2px solid green;
            outline: none;
            padding-left: 0px;
            font-weight: bold;
            margin-right: 5px;
        }

        button {
            width: 80%;
        }

    }

`

const Warning = styled.div`
    width: 500px;
    background-color: var(--error);
    margin: 10px auto;
    border-radius: 5px;
    box-shadow: rgba(99, 99, 99, 0.4) 0px 2px 8px 0px;

    p {
        font-size: 11px;
        color: #fff;
        padding: 10px;
        text-align: justify
    }

    @media (max-width: 928px) {

        width: 90%;

        p {
            padding: 10px 5px;

            b {
                font-size: 14px;
            }
        }

    }
    
`

const Chartbox = styled.div`

    h1 {
        font-size: 46px;
        padding: 0 0 0 30px;
        color: #333;
    }

    h3 {
        padding: 20px 0 0 30px;
        color: #333;
    }

    p {
        padding: 0 0 0 30px;
        font-size: 16px;
        color: #333;
        font-weight: 300;

        span {
            font-weight: bold;
            font-size: 16px;
        }
    }

    @media (max-width: 768px) {

        h1 {
            font-size: 32px;
            padding: 5px 0 0 30px;
        }

        h3 {
            padding: 10px 0 0 30px;
        }

        p {
            padding: 5px 0 0 30px;
            font-size: 11px;
        }

    }

`

const Chart = styled.div`

width: 100%;
height: 300px;
margin-top: 30px;

@media (max-width: 768px) {
    margin-top: 20px;
}

`

const TimelineButtons = styled.div`

    display:flex;
    justify-content: right;
    padding-right: 20px;

    button {
        width: 70px;
        height: 40px;
        border: none;
        font-size: 10px;
        font-weight: bold;
        margin-right: 3px;
        background-color: var(--primary);
        color: #fff;
        margin-bottom: 50px;
        border-radius: 5px;
    }

    @media (max-width: 768px) {
        justify-content: center;
    }


`
